import { ComponentInterface } from '@fusioncharts/core/src/component-interface';
import { componentFactory, TRACKER_FILL } from '@fusioncharts/core/src/lib';
import NumericAxis from '@fusioncharts/core/src/axis/numeric';
import CheckBox from '@fusioncharts/core/src/toolbox/tools/checkbox';

const checkboxTopPadding = 4;
let removeInfo = function (_existingAxes, _axisMapById) {
    let key,
      _info,
      i;
    for (i = _existingAxes.length - 1; i > -1; i--) {
      key = _existingAxes[i];
      _info = _axisMapById.get(key);
      _info.checkbox && _info.checkbox.remove();
      _info.axis && _info.axis.remove();
      _axisMapById['delete'](key);
    }
  },
  swap = (a, b, map) => {
    let e1 = [a, map.get(a)], // eslint-disable-line good-practices/no-single-usage-variable
      e2 = [b, map.get(b)], // eslint-disable-line good-practices/no-single-usage-variable
      mapArray = Array.from(map.entries()), // eslint-disable-line good-practices/no-single-usage-variable
      newMapArray = mapArray.map(([key, value]) => { // eslint-disable-line good-practices/no-single-usage-variable
        if (key === a) {
          return e2;
        } else if (key === b) {
          return e1;
        }
        return [key, value];
      });
    return new Map(newMapArray);
  },
  factoryAxis = function (parent) {
    let axesConf = parent.config.axesConf,
      axes,
      axisMapById,
      activeAxis,
      existingInfo,
      exsitingAxisMapById = parent.config.axisMapById,
      existingAxes = (exsitingAxisMapById && Array.from(exsitingAxisMapById.keys())) || [],
      info,
      firstAxis = true, // eslint-disable-line good-practices/no-single-usage-variable
      canvas = parent.getFromEnv('chart').getChildren('canvas')[0],
      axisRefVisualCartesian = canvas.getChildren('axisRefVisualCartesian')[0],
      redraw = () => axisRefVisualCartesian.asyncDraw(), // eslint-disable-line good-practices/no-single-usage-variable
      removeId = function (id) {
        let index = existingAxes.indexOf(id);
        (index !== -1) && existingAxes.splice(index, 1);
      };

    componentFactory(parent, NumericAxis, 'yAxis', axesConf.length, axesConf);

    axes = (parent.getChildren('yAxis') || []).slice(0);
    axisMapById = parent.config.axisMapById = new Map(); // eslint-disable-line good-practices/no-single-usage-variable
    (parent.config.side === 'l' ? axes.reverse() : axes).forEach((axis) => {
      if (axis.getState('removed') || axis.config.showaxis === 0) {
        return;
      }
      let axisId = axis.getId();
      info = {};
      info.axis = axis;
      existingInfo = exsitingAxisMapById && exsitingAxisMapById.get(axisId);
      info.checkbox = existingInfo && existingInfo.checkbox;
      axisMapById.set(axisId, info);
      if (axis.config.showaxis === 0) {
        axis.hide();
      } else {
        axis.show();
      }
      canvas.attachAxis(axis, true);
      firstAxis && (parent.config.besideCanvas = axisId);
      firstAxis = false; // eslint-disable-line good-practices/no-single-usage-variable
      if (!axisCount) {
        activeAxis = axis;
      }
      axis.setLinkedItem('canvas', canvas);
      axisRefVisualCartesian.setLinkedItem(axis.getId(), axis);
      axisRefVisualCartesian.addExtEventListener('visiblerangeset', redraw, axis);
      axisCount++;
      removeId(axisId);
    });
    activeAxis && canvas.setPrimaryAxis('yAxis', activeAxis);
    removeInfo(existingAxes, exsitingAxisMapById);
  },
  axisCount = 0;
/**
 * This module handles the customized UI for axis in multiaxis charts
 */
class AxisSelectorUI extends ComponentInterface {
  /**
   * constructor fn
   */
  constructor () {
    super();
    this.registerFactory('axis', factoryAxis);
  }
  /**
   * reset axis count
   */
  static resetAxisCount () {
    axisCount = 0;
  }
  /**
   * function to configure this component by given configuration
   * @param {Object} conf configuration object
   */
  configureAttributes (conf = {}) {
    let config = this.config;
    config.axesConf = (conf.axesConf || []);
    config.checkboxesConf = conf.checkboxesConf || [];
    config.side = conf.side;
  }
  /**
   * function to allocate and calculate total required space
   * @param {Number} avlWidth avialable width to allocated
   */
  placeAxis (avlWidth) {
    let axisSelectorUI = this,
      availableWidth = avlWidth,
      side = axisSelectorUI.config.side, // eslint-disable-line good-practices/no-single-usage-variable
      axisMapById = axisSelectorUI.getAxesDetails(), // eslint-disable-line good-practices/no-single-usage-variable
      axesPadding = axisSelectorUI.getFromEnv('chartConfig').axesPadding,
      rightPadding = 0, // eslint-disable-line good-practices/no-single-usage-variable
      leftPadding = 0, // eslint-disable-line good-practices/no-single-usage-variable
      dim,
      dimension = {
        right: 0,
        left: 0
      };

    axisMapById.forEach((info) => {
      let value = (info.value || (info.value = {})),
        axis = info.axis;
      if (axis.getState('removed') || axis.config.showaxis === 0) {
        return;
      }
      dim = axis.placeAxis(availableWidth * 0.7);
      if (side === 'r') {
        availableWidth -= (value.width = dim.right);
        dimension.right += dim.right;
        rightPadding += axesPadding;
      } else {
        availableWidth -= (value.width = dim.left);
        dimension.left += dim.left;
        leftPadding += axesPadding;
      }
    });

    return { dimension, rightPadding, leftPadding };
  }
  /**
   * calculate post space management related calculation
   */
  setAxisDimention () {
    let axisSelectorUI = this,
      conf = axisSelectorUI.config,
      axisMapById = axisSelectorUI.getAxesDetails(), // eslint-disable-line good-practices/no-single-usage-variable
      axesPadding = axisSelectorUI.getFromEnv('chartConfig').axesPadding,
      canvasConfig = axisSelectorUI.getFromEnv('chart').getChildren('canvas')[0].config,
      canvasBorderWidth = canvasConfig.canvasBorderWidth,
      canvasPaddingTop = canvasConfig.canvasPaddingTop,
      canvasPaddingBottom = canvasConfig.canvasPaddingBottom, // eslint-disable-line good-practices/no-single-usage-variable
      canvasLeft = canvasConfig.canvasLeft,
      canvasTop = canvasConfig.canvasTop, // eslint-disable-line good-practices/no-single-usage-variable
      canvasHeight = canvasConfig.canvasHeight, // eslint-disable-line good-practices/no-single-usage-variable
      canvasRight = canvasLeft + canvasConfig.canvasWidth,
      isRight = conf.side === 'r', // eslint-disable-line good-practices/no-single-usage-variable
      oppositePos = conf.side === 'r' ? (canvasLeft - canvasBorderWidth) : (canvasRight + canvasBorderWidth), // eslint-disable-line good-practices/no-single-usage-variable
      padding = 0;

    axisMapById.forEach((info) => {
      let value = (info.value || (info.value = {})),
        axis = info.axis;
      if (axis.config.showaxis === 0 || axis.getState('removed')) {
        return;
      }

      if (isRight) {
        value.x = canvasRight + canvasBorderWidth + padding + axesPadding;
      } else {
        value.x = canvasLeft - canvasBorderWidth - padding - axesPadding;
      }
      value.y = canvasTop + canvasPaddingTop;
      value.height = canvasHeight - canvasPaddingTop - canvasPaddingBottom;
      value.opposite = oppositePos;
      padding += value.width + axesPadding;

      axis.setAxisDimention({
        x: value.x,
        y: value.y,
        opposite: value.opposite,
        axisLength: value.height
      });
    });
  }
  /**
   * function to draw hot elements of axes.
   * It helps to interact with axes
   */
  drawHotElements () {
    let axisSelectorUI = this,
      conf = axisSelectorUI.config,
      isRight = conf.side === 'r', // eslint-disable-line good-practices/no-single-usage-variable
      allowAxisShift = axisSelectorUI.getFromEnv('chartConfig').allowAxisShift, // eslint-disable-line good-practices/no-single-usage-variable
      chart = axisSelectorUI.getFromEnv('chart'),
      axisMapById = conf.axisMapById, // eslint-disable-line good-practices/no-single-usage-variable
      axisHotElements = axisSelectorUI.getGraphicalElement('axisHotElement') || [],
      k,
      length,
      counter = -1,
      attr = {
        cursor: 'col-resize',
        stroke: TRACKER_FILL,
        fill: TRACKER_FILL,
        visibility: true
      };

    if (allowAxisShift) {
      axisMapById.forEach((info, key) => {
        let hotElement,
          value = info.value;
        attr.x = value.x + (isRight ? 0 : -value.width);
        attr.y = value.y;
        attr.width = value.width;
        attr.height = value.height;
        // Creating the hot element if not created
        if (!(hotElement = axisHotElements[++counter])) {
          hotElement = axisSelectorUI.addGraphicalElement('axisHotElement', axisSelectorUI.getFromEnv('paper').rect(chart.getChildContainer('trackerGroup')), true);
          hotElement.on('fc-click', axisSelectorUI._resuffelAxis);
        }
        hotElement.attr(attr).data('axisDetails', {
          axisSelectorUI: axisSelectorUI,
          canvas: chart.getChildren('canvas')[0],
          axisId: key
        });
      });
    }

    for (k = counter + 1, length = axisHotElements.length; k < length; k++) { // eslint-disable-line good-practices/no-single-usage-variable
      axisSelectorUI.removeGraphicalElement(axisHotElements[k]);
    }
  }
  /**
   * function to draw checkboxes
   */
  drawCheckBoxes () {
    let axisSelectorUI = this,
      conf = axisSelectorUI.config,
      // chartId = axisSelectorUI.getFromEnv('chartInstance').id,
      chartConfig = axisSelectorUI.getFromEnv('chartConfig'),
      // chart = axisSelectorUI.getFromEnv('chart'),
      // checkBoxContainer = chart.getChildContainer('buttonGroup'),
      // toolBoxAPI = axisSelectorUI.getFromEnv('toolBoxAPI'),
      // tb = axisSelectorUI.getFromEnv('toolbox'),
      // CheckboxSymbol = toolBoxAPI.CheckboxSymbol,
      isRight = conf.side === 'r', // eslint-disable-line good-practices/no-single-usage-variable
      axisMapById = conf.axisMapById;

    if (chartConfig.allowSelection) {
      axisMapById.forEach((info, key) => {
        let value = info.value,
          currCheckBox = info.checkbox,
          axisConfig = info.axis.config,
          checkboxClickHandler = function () {
            let tool = this;

            tool.toggle();
            axisSelectorUI._dolegendInteraction.call(tool, key, tool.getFromEnv('chart'));
            axisConfig.checkBoxChecked = !axisConfig.checkBoxChecked;
          },
          // state = 'updating',
          padding = isRight ? info.axis.getAxisConfig('axisNamePadding') : -value.width; // eslint-disable-line good-practices/no-single-usage-variable

        if (!currCheckBox) {
          currCheckBox = info.checkbox = new CheckBox();
          axisSelectorUI.attachChild(currCheckBox, 'checkbox', true);
          currCheckBox.configure({
            isChecked: true,
            text: '',
            stroke: chartConfig.checkBoxColor,
            symbolStroke: chartConfig.checkBoxColor,
            strokeWidth: 1,
            symbolStrokeWidth: 1,
            containerInfo: {
              id: 'buttonGroup',
              label: 'group',
              isParent: true
            }
          });
          currCheckBox.addEventListener('fc-click', checkboxClickHandler);
        }
        currCheckBox.setDimension({
          x: value.x + padding,
          y: value.y + value.height + checkboxTopPadding
        });
      });
    } else {
      axisMapById.forEach((info, key) => {
        info.checkbox && info.checkbox.remove();
        delete info.checkbox;
      });
    }
  }
  _createLayers () {
    let axisSelectorUI = this,
      parentLayer = axisSelectorUI.getFromEnv('chart').getChildContainer('selectorGroup');
    axisSelectorUI.createContainer('axisBottomGroup', { name: 'axis-bottom-group' }, parentLayer);
    axisSelectorUI.createContainer('axisTopGroup', { name: 'axis-top-group' }, parentLayer);
    axisSelectorUI.createContainer('buttonGroup', { name: 'buttons' }, parentLayer);
  }

  createContainer (containerName, attr, container) {
    return this.addChildContainer(containerName, this.getFromEnv('animationManager').setAnimation({
      container,
      attr,
      el: this.getChildContainer(containerName) || 'group',
      component: this,
      label: 'group'
    }));
  }
  /**
   * function to handle draw job
   */
  draw () {
    this._createLayers();
    this.drawHotElements();
    this.drawCheckBoxes();
  }
  /**
   * Function to swap axis on click
   */
  _resuffelAxis () {
    var data = this.data('axisDetails'),
      axisSelectorUI = data.axisSelectorUI,
      conf = axisSelectorUI.config,
      canvas = data.canvas,
      axisId = data.axisId,
      axesDetails = axisSelectorUI.getAxesDetails();
    if (conf.besideCanvas !== axisId) {
      axesDetails = axisSelectorUI.config.axisMapById = swap(conf.besideCanvas, axisId, axesDetails);
    }
    conf.besideCanvas = axisId;
    canvas.setPrimaryAxis('yAxis', axesDetails.get(axisId).axis);
    axisSelectorUI.setAxisDimention();

    axisSelectorUI.asyncDraw();
    canvas.getChildren('axisRefVisualCartesian')[0].asyncDraw();
  }
  /**
   * Function to manipulate legends on checkbox click
   * @param {number} axisIndex The index of the axis against which the checkbox is clicked
   * @param {Object} chart the chart object
   */
  _dolegendInteraction (axisId, chart) {
    var checkbox = this,
      datasets = [],
      // legend = iapi.getChildren('legend'),
      obj,
      dataset;

    chart.iterateComponents((child) => {
      if ((child.getType() === 'dataset')) {
        datasets.push(child);
      }
    });

    for (obj in datasets) {
      if (datasets.hasOwnProperty(obj)) {
        dataset = datasets[obj];
        if (dataset.getFromEnv('yAxis').getId() === axisId) {
          if (!dataset.getState('visible') && checkbox.config.checked) {
            dataset.config.legendInteractivity = true;
            dataset.show();
          } else if (dataset.getState('visible') && !checkbox.config.checked) {
            dataset.config.legendInteractivity = true;
            dataset.hide();
          }
        }
      }
    }
    // legend.drawLegend();
  }
  /**
   * Function to change the state of the checkbox when legend is clicked
   * @param {Object} e The evet object
   */
  manipulateCheckBox (e) {
    var data = e.data,
      clickedDS = data.dataset,
      axisId = clickedDS.getFromEnv('yAxis').getId(), // eslint-disable-line good-practices/no-single-usage-variable
      vCanvas = clickedDS.getLinkedParent(), // eslint-disable-line good-practices/no-single-usage-variable
      allDS = vCanvas.getChildren().dataset,
      checkboxUncheck = true, // eslint-disable-line good-practices/no-single-usage-variable
      i,
      len,
      dataset,
      info,
      axisMapById = this.getAxesDetails(); // eslint-disable-line good-practices/no-single-usage-variable

    if (!(info = axisMapById.get(axisId))) {
      return;
    }
    if (data.state === 'hide') {
      for (i = 0, len = allDS.length; i < len; i++) {
        dataset = allDS[i];
        if (dataset.getState('visible')) {
          checkboxUncheck = false;
        }
      }
      if (checkboxUncheck) {
        info.checkbox && info.checkbox.uncheck();
      }
    } else {
      info.checkbox && info.checkbox.check();
    }
  }
  /**
   * return axis components
   * @return {Object} axesMap
   */
  getAxesDetails () {
    return this.config.axisMapById;
  }
  /**
   * return type of this component
   */
  getType () {
    return 'customAxisUI';
  }
  /**
   * return name of this component
   */
  getName () {
    return 'multiAxisSelectorUI';
  }
  /**
   * function to return axes attached to this comp.
   * This API is for external invocation whre the axes
   * is required from the outside components.
   * @return {Array} - axes
   */
  getAxes () {
    // eslint-disable-next-line good-practices/no-function-dependency
    return Array.from(this.config.axisMapById.values()).map(elem => elem.axis);
  }
}
export default AxisSelectorUI;
